import React, { useRef } from 'react'
import Lottie, { LottieComponentProps, LottieRefCurrentProps } from 'lottie-react'
import homeIconAnimation from './circle.json'
import styles from './index.module.scss'

export interface LottieHomeIconProps extends Omit<LottieComponentProps, 'animationData'> {
  /** 自定义样式类名 */
  className?: string
  /** 容器宽度 */
  width?: number | string
  /** 容器高度 */
  height?: number | string
}

const LottieHomeIcon: React.FC<LottieHomeIconProps> = ({
  className = '',
  width,
  height,
  ...props
}) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null)

  const containerStyle: React.CSSProperties = {
    width: width || '100%',
    height: height || '100%'
  }

  const containerClass = [styles.lottieContainer, className].filter(Boolean).join(' ')

  return (
    <div className={containerClass} style={containerStyle}>
      <Lottie
        lottieRef={lottieRef}
        animationData={homeIconAnimation}
        loop={true}
        autoplay={true}
        {...props}
      />
    </div>
  )
}

export default LottieHomeIcon
